export class ContributionFilter {
    constructor(itemsPerPage: number = 5, page: number = 1, initialdate: Date | any, finaldate: Date | any, type: string = 'normal') {
        this.itemsPerPage = itemsPerPage;
        this.page = page;
        this.initialdate = initialdate;
        this.finaldate = finaldate;
        this.type = type;
    }
    itemsPerPage: number;
    page: number;
    initialdate: Date;
    finaldate: Date;
    type: string;
}